import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { Flex, Grid, Image } from '@mantine/core';

import styles from './styles.module.scss';
import { useMediaQuery } from '@mantine/hooks';
import { AuthHeader } from '../AuthWrapper/components';
import imageShape1 from 'src/assets/images/scanningSlide.png'
import imageShape2 from 'src/assets/images/champion.png'
import imageShape4 from 'src/assets/svg/shape_1.svg'
import { Link } from 'react-router-dom';
import LogoImage from 'src/assets/svg/logo.svg';
import { PATHS } from 'src/constants';
import { useTranslation } from 'react-i18next';

interface Props {
  leftColumn: ReactNode;
}

const AuthWrraperGrid: FC<Props> = ({ leftColumn  }: Props): JSX.Element => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [t] = useTranslation('nav');

  return (
    <>
    <Grid id="main-wrapper" h={'100%'} className={styles.grid_container } tabIndex={-1}>
      
      <Grid.Col className={classNames(styles.column, styles.left  )} span={isMobile ? 12 : 6}>
          
          <div className={styles.leftContainer} >
            <header style={{ padding : '1rem'}}>
              <Link id="main-logo" to={PATHS.WEBSITE} >
                <Image width={142} src={LogoImage} alt={t('logoAlt') ?? undefined} />
              </Link>
            </header>
          { leftColumn }
          <img className={styles.imageShaptag} aria-hidden="true" src={imageShape4} alt="" />
        </div>
      </Grid.Col>
      <Grid.Col id="main-wrapper" className={`${styles.column} ${styles.shapColumn}`} span={isMobile ? 12 : 6}>
        <div className={styles.gridRightColumn}>
            <div className={styles.shap} style={{ backgroundColor : '#a3e6e1'}}></div>
            <div><img className={styles.imageContainer} src={imageShape1} alt="" /></div>
            <div> <img  className={styles.imageContainer}  src={imageShape2} alt="" /> </div>
            <div className={styles.shap} style={{ backgroundColor : "#5b5eff"}} ></div>
        </div>
      </Grid.Col>
    </Grid>
  </>
  );
};

export default AuthWrraperGrid;
